import React, { FC, ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import BackIconWhite from '../assets/icons/back-icon-white.svg';
import closeIcon from '../assets/icons/close-icon.svg';
import { ColorKey, Colors } from '../constants/constants';

interface BasicDialogProps {
  closeDialog?: () => void,
  open: boolean,
  title: string,
  children: ReactNode;
  allowCloseOnBackdrop?: boolean,
  headerColor?: ColorKey,
  loginStyle?: boolean,
  trackingModal?: boolean,
  twoFaStyle?: boolean,
}

const DIALOG_Z_INDEX = 10000000000000000;

const BasicDialog: FC<BasicDialogProps> = (props) => {
  const { t } = useTranslation();
  const titleParts = props.title.split('/');

  return (
    <Dialog
      open={props.open}
      maxWidth="md"
      onClose={(event, reason) => {
        if (!props.allowCloseOnBackdrop && reason === 'backdropClick') {
          return;
        }
        props.closeDialog?.();
      }}
      sx={{
        zIndex: DIALOG_Z_INDEX,
        '& .MuiBackdrop-root': {
          backgroundColor: Colors.primary,
          opacity: '20% !important',
        },
        '& .MuiDialog-paper': {
          borderRadius: '8px',
          minWidth: props.loginStyle ? 505 : 500,
          minHeight: props.twoFaStyle ? 100 : 200,
          boxShadow: 'none',
          maxWidth: 'calc(100% - 32px)',
          margin: 2,
        },
        '@media (max-width: 768px)': {
          '& .MuiDialog-paper': {
            minWidth: 'unset',
          },
        },
      }}
    >
      <div
        className={props.trackingModal ? 'flex items-center  justify-center gap-5 rounded-t-lg border-b-2 px-6 py-4'
          : props.twoFaStyle ? 'flex flex-row-reverse  items-center justify-between gap-5 rounded-t-lg border-b-2 px-6 py-4'
            : ' flex items-center  border-b-2  py-[19px]'}
        style={{ backgroundColor: props.headerColor ? Colors[props.headerColor] : Colors.white }}
      >
        {props.headerColor === 'gray-5' || !props.headerColor ? (
          <p className="m-auto text-center font-medium text-primary">
            {titleParts.length > 1 ? (
              <>
                <span className="text-gray-3">{titleParts[0].trim()}</span>
                <span className="accent-primary"> / </span>
                <span className="accent-primary">{titleParts[1].trim()}</span>
              </>
            ) : (
              t(props.title)
            )}
          </p>
        ) : (
          <>
            {props.closeDialog && (
            <button
              type="button"
              className="p-1 duration-100 hover:opacity-70 active:opacity-50"
              onClick={props.closeDialog}
            >
              <img src={props.twoFaStyle ? closeIcon : BackIconWhite} alt="" />
            </button>
            )}
            <p className={`${props.headerColor === 'white' ? 'text-center' : 'text-white'}`}>
              <span className={`font-medium ${titleParts[1] ? 'text-[#BDBDBD]' : 'text-primary'}`}>
                {' '}
                {t(titleParts[0])}
              </span>
              {titleParts[1] && (
              <span className="font-semibold text-primary">
                {' '}
                /
                {' '}
                {t(titleParts[1])}
              </span>
              )}
            </p>
          </>
        )}
      </div>
      <div className="w-full max-w-[500px] px-7 py-5">
        {props.children}
      </div>
    </Dialog>
  );
};

export default BasicDialog;
